import VisionDentalMedicalIcon from './VisionDentalMedicalIcon'

export default VisionDentalMedicalIcon
